import { useCallback } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

import { mergeWithFilteredQueryParams } from '@neo.tax/shared/utils';

export const useNavigateTo = (): ((to: To, options?: NavigateOptions) => void) => {
  const navigate = useNavigate();
  const navigateTo = useCallback(
    (to: To, options?: NavigateOptions): void => {
      // Object-form `to` (`{pathname, search, hash}`) is passed through unchanged:
      // callers using that shape own the full URL composition.
      if (typeof to !== 'string') {
        navigate(to, options);
        return;
      }
      navigate(mergeWithFilteredQueryParams(to), options);
    },
    [navigate],
  );

  return navigateTo;
};
